import feathers from '@feathersjs/client'
import io from 'socket.io-client'
import store from '../store'

const apiURL = process.env.VUE_APP_API_URL

const socket = io(apiURL, { path: process.env.VUE_APP_API_PATH, transports: ['websocket'] })

let timeout = null
socket.on('connect', () => {
  if (timeout != null) clearTimeout(timeout)
  timeout = null
  store.commit('setOffline', false)
})
socket.on('disconnect', () => {
  timeout = setTimeout(() => store.commit('setOffline', true), 5000)
})

const $feathers = feathers()
  .configure(feathers.socketio(socket, { timeout: 10000 }))
  .configure(feathers.authentication({ storage: window.localStorage }))

export {
  $feathers
}
